// Display names for roles. Built-in roles have translated names; roles an
// administrator added on the Roles page show the name given there.
import type { Role, RoleDef } from './api/types';
import type { MessageKey } from './i18n';

type T = (key: MessageKey) => string;

const BUILT_IN = new Set<Role>(['admin', 'creator', 'analyst', 'respondent', 'enumerator']);

export const isBuiltInRole = (key: Role) => BUILT_IN.has(key);

export function roleLabel(t: T, key: Role, name?: string): string {
  return isBuiltInRole(key) ? t(`role.${key}` as MessageKey) : name || key;
}

export function roleDescription(t: T, role: Pick<RoleDef, 'key' | 'description'>): string {
  return isBuiltInRole(role.key) ? t(`role.${role.key}.desc` as MessageKey) : role.description;
}
